import React, { FC, useContext, useEffect, useState } from 'react';
import { Modal, Select } from 'esa-ui-library';
import { AuthContext } from '../../../../../logic';
import { getPartnerGameSettings, getFilterOptions } from '../../../../../api';
import styles from './PartnerGameSettings.module.scss';

type ValueType = {
	label: string;
	value: string;
};

interface PartnerGameSettingsProps {
	partnerId: number;
	partnerName: string;
	partner: string;
	gameId: number;
	onClose: () => void;
}

const PartnerGameSettings: FC<PartnerGameSettingsProps> = ({
	partnerId,
	partnerName,
	partner,
	gameId,
	onClose,
}): JSX.Element => {
	const { token } = useContext(AuthContext);
	const [settings, setSettings] = useState<string>('');
	const [loading, setLoading] = useState<boolean>(true);
	const [currency, setCurrency] = useState<string>('EUR');
	const [currencies, setCurrencies] = useState<ValueType[]>([]);

	useEffect(() => {
		const fetchCurrencies = async () => {
			try {
				const response: any = await getFilterOptions({ token, filters: ['currencies'] });
				if (response?.data?.currencies) {
					setCurrencies(response.data.currencies);
				}
			} catch (error) {
				//
			}
		};
		fetchCurrencies();
	}, [token]);

	useEffect(() => {
		const fetchSettings = async () => {
			setLoading(true);
			try {
				const response: any = await getPartnerGameSettings({
					token,
					partner_id: partnerId,
					game_id: gameId,
					currency,
				});
				if (response?.data?.return) {
					const allSettings = response.data.return;
					const filteredSettings = {
						game_defaults: allSettings.game_defaults,
						max_exposure: allSettings.max_exposure,
						max_exposure_set: allSettings.max_exposure_set,
						currency: allSettings.currency,
						precision: allSettings.precision,
						valid_bets: allSettings.valid_bets,
					};
					setSettings(JSON.stringify(filteredSettings, null, 2));
				}
			} catch (error) {
				//
			} finally {
				setLoading(false);
			}
		};

		fetchSettings();
	}, [partnerId, gameId, token, currency]);

	return (
		<Modal
			title={`Partner Game Settings - ${partner} (${partnerName}) - Skin ID: ${partnerId}`}
			onCancel={onClose}
			onSubmit={onClose}
			submitLabel='Close'
		>
			<div className={styles.PartnerGameSettings}>
				<div className={styles.CurrencySelector}>
					<Select
						label='Currency'
						options={currencies}
						selected={currencies.filter((c) => c.label === currency)}
						onChange={(val: any) => {
							if (val && val.length > 0) {
								setCurrency(val[0].label);
							}
						}}
						placeholder='Select currency'
					/>
				</div>
				{loading ? <p>Loading...</p> : <textarea value={settings} readOnly spellCheck={false} />}
			</div>
		</Modal>
	);
};

export { PartnerGameSettings };
